import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((muiTheme: Theme) => ({
    form: {
        display: "flex",
        flexDirection: "column",
        gap: muiTheme.spacing(3),
    },
    reviveButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: muiTheme.spacing(2),
        padding: muiTheme.spacing(2, 4),
        border: `1px solid ${muiTheme.palette.emteria.border.primary}`,
        borderRadius: muiTheme.spacing(1),
        backgroundColor: muiTheme.palette.emteria.background.default,
        color: muiTheme.palette.emteria.success,
        fontSize: "1rem",
        fontWeight: 500,
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
    },
    row: {
        marginBottom: muiTheme.spacing(1),
    },
    subscriptionButtonContainer: {
        marginTop: muiTheme.spacing(3),
        paddingTop: muiTheme.spacing(2),
    },
    ownersHeader: {
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: muiTheme.spacing(2),
    },
    ownersActions: {
        display: "flex",
        gap: muiTheme.spacing(1),
    },
    bold: {
        fontWeight: "bold",
    },
}));
